/**
 * Created by tigran on 19.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const CompanyIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4286 5.07138V2.21423L4.57141 2.21423L4.57141 6.78566"
        stroke={color}
        strokeWidth="1.37143"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M6.85712 14.7858H9.14283"
        stroke={color}
        strokeWidth="1.37143"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M6.85715 8.5L1.71429 8.5L1.71429 14.7857H6.85715L6.85715 8.5Z"
        stroke={color}
        strokeWidth="1.37143"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M14.2857 6.78577L9.14288 6.78577L9.14288 14.7858L14.2857 14.7858L14.2857 6.78577Z"
        stroke={color}
        strokeWidth="1.37143"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M11.4286 9.07141H12"
        stroke={color}
        strokeWidth="1.37143"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M11.4286 10.7858H12"
        stroke={color}
        strokeWidth="1.37143"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M11.4286 12.5H12"
        stroke={color}
        strokeWidth="1.37143"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M4 12.5H4.57143"
        stroke={color}
        strokeWidth="1.37143"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M4 10.7858H4.57143"
        stroke={color}
        strokeWidth="1.37143"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
    </svg>
  );
};
